import { Address } from "@/types";
import AddressTypeEnum from "@/constants/enums/AddressTypeEnum";

export function findDeliveryAddress(addresses: Address[]) {
  function buildAddress(address: Address) {
    return `${address.address}, ${address.postCode} ${address.place}, ${address.country.name}`;
  }
  const shippingAddress = addresses.find((address) => address.addressType === AddressTypeEnum.SHIPPING);
  if (shippingAddress) {
    return buildAddress(shippingAddress);
  }
  const visitingAddress = addresses.find((address) => address.addressType === AddressTypeEnum.VISITING);
  if (visitingAddress) {
    return buildAddress(visitingAddress);
  }
  const billingAddress = addresses.find((address) => address.addressType === AddressTypeEnum.BILLING);
  if (billingAddress) {
    return buildAddress(billingAddress);
  }
  const homeAddress = addresses.find((address) => address.addressType === AddressTypeEnum.HOME);
  if (homeAddress) {
    return buildAddress(homeAddress);
  }
}
